/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ClaimsRevocationRegistry,
  ClaimsRevocationRegistryInterface,
} from "../ClaimsRevocationRegistry";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_didRegistry",
        type: "address",
      },
      {
        internalType: "address",
        name: "_ensRegistry",
        type: "address",
      },
      {
        internalType: "address",
        name: "_claimManager",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "subject",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "revoker",
        type: "address",
      },
    ],
    name: "Revoked",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "subject",
        type: "address",
      },
      {
        internalType: "address",
        name: "revoker",
        type: "address",
      },
    ],
    name: "revokeClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address[]",
        name: "subjects",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "revoker",
        type: "address",
      },
    ],
    name: "revokeClaimsInList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "subject",
        type: "address",
      },
    ],
    name: "isRevoked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "subject",
        type: "address",
      },
    ],
    name: "getRevocationDetail",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ClaimsRevocationRegistryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ClaimsRevocationRegistryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ClaimsRevocationRegistry__factory extends ContractFactory {
  constructor(...args: ClaimsRevocationRegistryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ClaimsRevocationRegistry";
  }

  deploy(
    _didRegistry: string,
    _ensRegistry: string,
    _claimManager: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ClaimsRevocationRegistry> {
    return super.deploy(
      _didRegistry,
      _ensRegistry,
      _claimManager,
      overrides || {}
    ) as Promise<ClaimsRevocationRegistry>;
  }
  getDeployTransaction(
    _didRegistry: string,
    _ensRegistry: string,
    _claimManager: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _didRegistry,
      _ensRegistry,
      _claimManager,
      overrides || {}
    );
  }
  attach(address: string): ClaimsRevocationRegistry {
    return super.attach(address) as ClaimsRevocationRegistry;
  }
  connect(signer: Signer): ClaimsRevocationRegistry__factory {
    return super.connect(signer) as ClaimsRevocationRegistry__factory;
  }
  static readonly contractName: "ClaimsRevocationRegistry";
  public readonly contractName: "ClaimsRevocationRegistry";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ClaimsRevocationRegistryInterface {
    return new utils.Interface(_abi) as ClaimsRevocationRegistryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ClaimsRevocationRegistry {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ClaimsRevocationRegistry;
  }
}
